
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { ManufacturerType, ManufacturerPayloadType } from "@/common/types/manufacturer";

export async function manufacturerList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `manufacturer/list${queryString}`
    );
}

export async function manufacturerGet(
    manufacturer_id: string
) {
    return await clientAxios.get(
        `manufacturer/${manufacturer_id}/show`
    );
}

export async function manufacturerAdd(
    payload: ManufacturerPayloadType
) {
    return await clientAxios.post(
        `manufacturer/create`,
        payload
    );
}

export async function manufacturerPatch(
    manufacturer_id: string,
    payload: Partial<ManufacturerType>
) {
    return await clientAxios.patch(
        `manufacturer/${manufacturer_id}/patch`,
        { payload }
    );
}

export async function manufacturerDel(
    manufacturer_id: string,
) {
    return await clientAxios.del(
        `manufacturer/${manufacturer_id}/delete`,
    );
}
